import type { TFunction } from 'i18next';
import { z } from 'zod';
// import { type useTranslations } from 'next-intl';

import { translateWithFallback } from '@/lib/i18n/helpers';

// Validacion de esquemas basada en TypeScript con inferencia de tipos estaticos
// https://zod.dev
export const loginCustomerSchema = (t: TFunction) => {
  return z.object({
    Username: z.string().min(2, {
      message: translateWithFallback(
        t,
        'Validations.LoginCustomer.username',
        'Ingresa un usuario válido (mínimo 2 caracteres).',
      ),
    }),
    Password: z
      .string({
        required_error: translateWithFallback(
          t,
          'Validations.LoginCustomer.password-required',
          'La contraseña es obligatoria.',
        ), // Mensaje cuando falta el campo
        invalid_type_error: translateWithFallback(
          t,
          'Validations.LoginCustomer.password-invalid-type',
          'Ingresa una contraseña válida.',
        ), // Mensaje cuando no es string
      })
      .trim() // Elimina espacios al inicio y final
      .min(8, {
        message: translateWithFallback(
          t,
          'Validations.LoginCustomer.password-min',
          'La contraseña debe tener al menos 8 caracteres.',
        ),
      }) // Longitud minima
      .max(254, {
        message: translateWithFallback(
          t,
          'Validations.LoginCustomer.password-max',
          'La contraseña no puede superar los 254 caracteres.',
        ),
      }),
  });
};

export type LoginCutomerRequest = z.infer<ReturnType<typeof loginCustomerSchema>>;

export interface LoginPayload {
  Username: string;
  Password: string;
}
